<template>
  <div class="grid grid-cols-12 gap-4">
    <div class="col-span-12">
      <div class="grid grid-cols-12 gap-4 pt-1">
        <div class="col-span-12">
          <div class="border-b border-gray-200">
            <nav class="flex space-x-6 px-4" aria-label="Tabs">
            <div :class="[(currentRoute === 'partners') ? 'border-primary text-primary' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300', 'whitespace-nowrap py-3 px-1 border-b-2 font-medium text-sm flex items-center space-x-2 transition cursor-pointer']" @click="select('partners')">
              <div class="flex mt-6">
                <div style="font-size: 14px">Partners</div>
                <span class="bg-gray text-white px-2 py-1 rounded-sm text-xs bg-primary mb-1 mx-1 ">
                  <span v-if="getBusinessPartners">
                    {{(getBusinessPartners.individualPartners.length + getBusinessPartners.corporatePartners.length)}}
                  </span>
                </span>
              </div>
            </div>
            <div :class="[(currentRoute === 'details') ? 'border-primary text-primary' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300', 'whitespace-nowrap py-3 px-1 border-b-2 font-medium text-sm flex items-center space-x-2 transition cursor-pointer']" @click="select('details')">
              <div class="flex mt-6">
                <div style="font-size: 14px">Address</div>
              </div>
            </div>
            <div :class="[(currentRoute === 'documents') ? 'border-primary text-primary' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300', 'whitespace-nowrap py-3 px-1 border-b-2 font-medium text-sm flex items-center space-x-2 transition cursor-pointer']" @click="select('documents')">
              <div class="flex mt-6">
                <div style="font-size: 14px">Documents</div>
                <span class="bg-gray text-white px-2 py-1 rounded-sm text-xs bg-primary mx-1 mb-1">
                  {{business.attachments.length}}
                </span>
              </div>
            </div>
            <div :class="[(currentRoute === 'filing-history') ? 'border-primary text-primary' : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300', 'whitespace-nowrap py-3 px-1 border-b-2 font-medium text-sm flex items-center space-x-2 transition cursor-pointer']" @click="select('filing-history')">
              <div class="flex mt-6">
                <div style="font-size: 14px">Filing History</div>
              </div>
            </div>
            </nav>
          </div>
        </div>
      </div>
      <div class="grid grid-cols-12 gap-4">
        <div class="col-span-12">
          <div class="grid grid-cols-12 gap-4">
            <BusinessNamePartners v-if="currentRoute === 'partners'"/>
            <BusinessNameDetails :file="business" v-if="currentRoute === 'details'"/>
            <BusinessNameDocuments :brn="business.brn" :documents="business.attachments" v-if="currentRoute === 'documents'"/>
            <FilingHistory :brn="business.brn" v-if="currentRoute === 'filing-history'"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from "vue";
import { useBusinessFileStore } from "@/stores/business-file";
import BusinessNamePartners
  from "@/domains/home/services/registry/business/files/tabs/business_name_data/BusinessNamePartners.vue";
import BusinessNameDetails
  from "@/domains/home/services/registry/business/files/tabs/business_name_data/BusinessNameDetails.vue";
import BusinessNameDocuments
  from "@/domains/home/services/registry/business/files/tabs/business_name_data/BusinessNameDocuments.vue";
import FilingHistory from "@/domains/home/services/registry/business/files/FilingHistory.vue";

const props = defineProps<{ business: any }>();

const fileStore = useBusinessFileStore();

const currentRoute = ref("partners");

const getBusinessPartners = computed(() => fileStore.partners);

onMounted(() => {
  fileStore.fetchBusinessNamePartners(props.business.brn);
});

const select = (route: string) => {
  currentRoute.value = route;
}
</script>

